document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".idp-header");
  const toggle = document.querySelector(".idp-menu-toggle");
  const slider = document.querySelector("[data-idp-slider]");
  const viewSections = Array.from(document.querySelectorAll("[data-idp-view]"));
  const cookieBanner = document.querySelector("[data-idp-cookie-banner]");
  const legalModal = document.querySelector("[data-idp-legal-modal]");

  const cookieStorageKey = "idp_cookie_preferences";

  const saveCookiePreferences = (preferences) => {
    window.localStorage.setItem(cookieStorageKey, JSON.stringify({
      necessary: true,
      preferences: Boolean(preferences.preferences),
      analytics: Boolean(preferences.analytics),
      updatedAt: new Date().toISOString()
    }));
    if (cookieBanner) cookieBanner.hidden = true;
  };

  const readCookiePreferences = () => {
    try {
      return JSON.parse(window.localStorage.getItem(cookieStorageKey) || "null");
    } catch (error) {
      return null;
    }
  };

  const syncCookieForm = () => {
    const preferences = readCookiePreferences();
    const form = document.querySelector("[data-idp-cookie-preferences]");
    if (!form || !preferences) return;
    form.elements.preferences.checked = Boolean(preferences.preferences);
    form.elements.analytics.checked = Boolean(preferences.analytics);
  };

  const openLegalModal = (panel = "preferences") => {
    if (!legalModal) return;
    legalModal.hidden = false;
    document.body.classList.add("idp-legal-open");
    legalModal.querySelectorAll("[data-idp-legal-panel]").forEach((element) => {
      element.hidden = element.dataset.idpLegalPanel !== panel;
    });
    legalModal.querySelectorAll("[data-idp-legal-tab]").forEach((button) => {
      button.classList.toggle("is-active", button.dataset.idpLegalTab === panel);
    });
    syncCookieForm();
    legalModal.querySelector(".idp-legal-modal__panel")?.focus();
  };

  const closeLegalModal = () => {
    if (!legalModal) return;
    legalModal.hidden = true;
    document.body.classList.remove("idp-legal-open");
  };

  if (cookieBanner && !readCookiePreferences()) {
    cookieBanner.hidden = false;
  }

  document.querySelectorAll("[data-idp-legal-open]").forEach((button) => {
    button.addEventListener("click", () => openLegalModal(button.dataset.idpLegalOpen));
  });

  document.querySelectorAll("[data-idp-legal-tab]").forEach((button) => {
    button.addEventListener("click", () => openLegalModal(button.dataset.idpLegalTab));
  });

  document.querySelectorAll("[data-idp-legal-close]").forEach((button) => {
    button.addEventListener("click", closeLegalModal);
  });

  document.querySelectorAll("[data-idp-cookie-accept]").forEach((button) => {
    button.addEventListener("click", () => saveCookiePreferences({ preferences: true, analytics: true }));
  });

  document.querySelectorAll("[data-idp-cookie-reject]").forEach((button) => {
    button.addEventListener("click", () => {
      saveCookiePreferences({ preferences: false, analytics: false });
      closeLegalModal();
    });
  });

  document.querySelector("[data-idp-cookie-preferences]")?.addEventListener("submit", (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    saveCookiePreferences({
      preferences: form.elements.preferences.checked,
      analytics: form.elements.analytics.checked
    });
    closeLegalModal();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeLegalModal();
  });

  const syncView = () => {
    const hash = window.location.hash.toLowerCase();
    const requestedView = {
      "#contacto": "contact",
      "#idp-contacto": "contact",
      "#idpcontactform": "contact",
      "#contact_form": "contact",
      "#sobre-nosotros": "about",
      "#idp-nosotros": "about",
      "#colores-deportivos": "sports-colors",
      "#colorizador-idp": "sports-colors",
      "#colores-industriales": "industrial-colors"
    }[hash] || (new URLSearchParams(window.location.search).has("contact_posted") ? "contact" : "");

    document.body.classList.toggle("idp-view-active", Boolean(requestedView));

    viewSections.forEach((section) => {
      const isActive = section.dataset.idpView === requestedView;
      const host = section.closest(".shopify-section");
      section.classList.toggle("is-active", isActive);
      host?.classList.toggle("idp-view-host", isActive);
      section.setAttribute("aria-hidden", String(!isActive));
    });

    document.querySelectorAll('.idp-nav a[href*="#"]').forEach((link) => {
      const linkHash = new URL(link.href, window.location.href).hash.toLowerCase();
      const isContact = requestedView === "contact" && ["#contacto", "#idp-contacto"].includes(linkHash);
      const isAbout = requestedView === "about" && ["#sobre-nosotros", "#idp-nosotros"].includes(linkHash);
      const isSportsColors = requestedView === "sports-colors" && ["#colores-deportivos", "#colorizador-idp"].includes(linkHash);
      const isIndustrialColors = requestedView === "industrial-colors" && linkHash === "#colores-industriales";
      link.classList.toggle("is-active", isContact || isAbout || isSportsColors || isIndustrialColors);
    });

    if (requestedView) {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  };

  syncView();
  window.addEventListener("hashchange", syncView);

  document.querySelectorAll(".idp-contact-form").forEach((form) => {
    const customerTypeInputs = Array.from(
      form.querySelectorAll('input[name="contact[Tipo de cliente]"]')
    );
    const professionalField = form.querySelector("[data-idp-professional-field]");
    const companyInput = professionalField?.querySelector("input");
    const subjectInput = form.querySelector("[data-idp-required-subject]");
    const contactEndpoint = form.querySelector("[data-idp-contact-endpoint]")?.value.trim();
    const contactStatus = form.querySelector("[data-idp-contact-status]");
    const contactSubmit = form.querySelector(".idp-contact-form__submit");
    const turnstileSiteKey = form.querySelector("[data-idp-turnstile-site-key]")?.value.trim();

    const syncCustomerType = () => {
      const isProfessional = customerTypeInputs.some(
        (input) => input.checked && input.value === "Profesional"
      );

      if (professionalField) professionalField.hidden = !isProfessional;
      if (companyInput) {
        companyInput.required = isProfessional;
        companyInput.disabled = !isProfessional;
      }
    };

    customerTypeInputs.forEach((input) => {
      input.addEventListener("change", syncCustomerType);
    });

    form.addEventListener("submit", (event) => {
      if (!subjectInput) return;

      const hasSubject = subjectInput.value.trim().length > 0;
      subjectInput.setCustomValidity(
        hasSubject ? "" : "Escribe un asunto para poder enviar la consulta."
      );

      if (!hasSubject) {
        event.preventDefault();
        subjectInput.reportValidity();
      }

      if (hasSubject && !validateSpamProtectedForm(form, { contact: true })) {
        event.preventDefault();
        return;
      }

      if (hasSubject && contactEndpoint) {
        event.preventDefault();
        if (turnstileSiteKey && !form.querySelector('[name="cf-turnstile-response"]')?.value) {
          if (contactStatus) {
            contactStatus.textContent = "Completa la verificacion de seguridad antes de enviar.";
            contactStatus.dataset.status = "error";
          }
          return;
        }
        submitSecureContact(form, {
          endpoint: contactEndpoint,
          status: contactStatus,
          submitButton: contactSubmit
        });
      }
    });

    subjectInput?.addEventListener("input", () => {
      subjectInput.setCustomValidity("");
    });

    syncCustomerType();
  });

  const pendingContactKey = "idp_pending_contact_message";
  const pendingContact = (() => {
    try {
      return JSON.parse(window.localStorage.getItem(pendingContactKey) || "null");
    } catch (error) {
      return null;
    }
  })();

  if (pendingContact) {
    document.querySelectorAll(".idp-contact-form").forEach((form) => {
      const subjectInput = form.querySelector('[name="contact[Asunto]"]');
      const bodyInput = form.querySelector('[name="contact[body]"]');

      if (subjectInput && !subjectInput.value) subjectInput.value = pendingContact.subject || "";
      if (bodyInput && !bodyInput.value) bodyInput.value = pendingContact.body || "";
    });
    window.localStorage.removeItem(pendingContactKey);
  }

  const spamSalesPattern = /(seo|backlink|guest post|marketing|agency|advertis|ranking|traffic|lead generation|web design|shopify expert|increase sales|partnership|colaboraci[oó]n comercial|crypto|casino|loan|forex|whatsapp marketing|bulk email|database|lista de emails)/i;
  const customerIntentPattern = /(m2|metro|metros|pavimento|suelo|resina|epoxi|poliuretano|impermeabil|terraza|garaje|parking|nave|obra|soporte|humedad|fisura|grieta|producto|ficha|precio|presupuesto|aplicaci[oó]n|maquinaria|diamant|granall|fresad|mortero|cubierta|pista)/i;

  const prepareSpamProtectedForm = (form) => {
    if (!form.dataset.idpStartedAt) {
      form.dataset.idpStartedAt = String(Date.now());
    }
  };

  const validateSpamProtectedForm = (form, { contact = false } = {}) => {
    prepareSpamProtectedForm(form);
    const elapsed = Math.round((Date.now() - Number(form.dataset.idpStartedAt || Date.now())) / 1000);
    const honeypot = form.querySelector("[data-idp-honeypot]");
    const verification = form.querySelector("[data-idp-spam-verification]");
    const elapsedField = form.querySelector("[data-idp-form-elapsed]");
    const subjectInput = form.querySelector('[name="contact[Asunto]"]');
    const bodyInput = form.querySelector("[data-idp-contact-body]");
    const firstInput = form.querySelector("input:not([type='hidden']), textarea");
    const text = `${subjectInput?.value || ""} ${bodyInput?.value || ""}`.trim();

    if (elapsedField) elapsedField.value = `${elapsed} segundos`;

    const block = (field, message) => {
      const target = field || firstInput;
      target?.setCustomValidity(message);
      target?.reportValidity();
      window.setTimeout(() => target?.setCustomValidity(""), 2500);
      return false;
    };

    if (honeypot?.value.trim()) {
      return block(firstInput, "No se pudo enviar la solicitud. Revisa el formulario e inténtalo de nuevo.");
    }

    if (elapsed < (contact ? 6 : 3)) {
      return block(firstInput, "Espera unos segundos y revisa el formulario antes de enviarlo.");
    }

    if (contact && bodyInput) {
      if (bodyInput.value.trim().length < 35) {
        return block(bodyInput, "Describe un poco más tu consulta para poder atenderla correctamente.");
      }

      if (spamSalesPattern.test(text) && !customerIntentPattern.test(text)) {
        return block(bodyInput, "Este formulario es solo para consultas reales sobre productos, obras o asesoramiento técnico IDP.");
      }
    }

    if (verification) verification.value = `Verificado en navegador: ${elapsed} segundos`;
    return true;
  };

  const submitSecureContact = async (form, { endpoint, status, submitButton }) => {
    if (form.dataset.idpSubmitting === "true") return;
    const formData = new FormData(form);
    const elapsedSeconds = Math.round((Date.now() - Number(form.dataset.idpStartedAt || Date.now())) / 1000);
    const payload = {
      website: formData.get("contact[website]") || "",
      name: formData.get("contact[name]") || "",
      email: formData.get("contact[email]") || "",
      phone: formData.get("contact[phone]") || "",
      customerType: formData.get("contact[Tipo de cliente]") || "",
      company: formData.get("contact[Empresa]") || "",
      subject: formData.get("contact[Asunto]") || "",
      body: formData.get("contact[body]") || "",
      fileReference: formData.get("contact[Referencia de archivo]") || "",
      elapsedSeconds,
      turnstileToken: formData.get("cf-turnstile-response") || ""
    };

    form.dataset.idpSubmitting = "true";
    if (submitButton) submitButton.disabled = true;
    if (status) {
      status.textContent = "Verificando consulta y enviando de forma segura...";
      status.dataset.status = "checking";
    }

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok || !result.ok) throw new Error(result.error || "No se pudo enviar la consulta.");

      form.reset();
      form.dataset.idpStartedAt = String(Date.now());
      const turnstileWidget = form.querySelector(".cf-turnstile");
      if (window.turnstile && turnstileWidget) window.turnstile.reset(turnstileWidget);
      if (status) {
        status.textContent = result.message || "Solicitud recibida correctamente. Te responderemos lo antes posible.";
        status.dataset.status = "success";
      }
    } catch (error) {
      const turnstileWidget = form.querySelector(".cf-turnstile");
      if (window.turnstile && turnstileWidget) window.turnstile.reset(turnstileWidget);
      if (status) {
        status.textContent = error.message || "No se pudo enviar la consulta. Intentalo de nuevo o contacta por telefono.";
        status.dataset.status = "error";
      }
    } finally {
      form.dataset.idpSubmitting = "false";
      if (submitButton) submitButton.disabled = false;
    }
  };

  document.querySelectorAll(".idp-contact-form, .idp-newsletter-form").forEach(prepareSpamProtectedForm);

  document.querySelectorAll(".idp-contact-form").forEach((form) => {
    const endpoint = form.querySelector("[data-idp-upload-endpoint]")?.value.trim();
    const dropzone = form.querySelector("[data-idp-dropzone]");
    const fileInput = form.querySelector("[data-idp-file-input]");
    const uploadButton = form.querySelector("[data-idp-upload-submit]");
    const uploadStatus = form.querySelector("[data-idp-upload-status]");
    const uploadReference = form.querySelector("[data-idp-upload-reference]");
    let selectedFile;

    const setUploadStatus = (message, type = "") => {
      if (!uploadStatus) return;
      uploadStatus.textContent = message;
      uploadStatus.dataset.status = type;
    };

    const setSelectedFile = (file) => {
      selectedFile = file;
      if (!file) return;
      const mb = (file.size / 1024 / 1024).toFixed(2);
      setUploadStatus(`Archivo seleccionado: ${file.name} (${mb} MB).`, "ready");
    };

    fileInput?.addEventListener("change", () => setSelectedFile(fileInput.files?.[0]));

    ["dragenter", "dragover"].forEach((eventName) => {
      dropzone?.addEventListener(eventName, (event) => {
        event.preventDefault();
        dropzone.classList.add("is-dragging");
      });
    });

    ["dragleave", "drop"].forEach((eventName) => {
      dropzone?.addEventListener(eventName, (event) => {
        event.preventDefault();
        dropzone.classList.remove("is-dragging");
      });
    });

    dropzone?.addEventListener("drop", (event) => {
      const file = event.dataTransfer?.files?.[0];
      if (fileInput && file) {
        const transfer = new DataTransfer();
        transfer.items.add(file);
        fileInput.files = transfer.files;
      }
      setSelectedFile(file);
    });

    uploadButton?.addEventListener("click", async () => {
      if (!endpoint) {
        setUploadStatus("La subida segura aun no esta activada. Falta configurar el endpoint del backend propio.", "error");
        return;
      }

      if (!selectedFile) {
        setUploadStatus("Selecciona o arrastra un archivo antes de subirlo.", "error");
        return;
      }

      if (selectedFile.size > 15 * 1024 * 1024) {
        setUploadStatus("El archivo supera el limite de 15 MB.", "error");
        return;
      }

      const formData = new FormData();
      formData.append("file", selectedFile);

      uploadButton.disabled = true;
      setUploadStatus("Subiendo archivo a cuarentena y verificando seguridad...", "checking");

      try {
        const response = await fetch(endpoint, { method: "POST", body: formData });
        const result = await response.json();
        if (!response.ok || !result.ok) throw new Error(result.error || "No se pudo verificar el archivo.");
        if (uploadReference) uploadReference.value = result.id;
        setUploadStatus(`Archivo verificado correctamente. Referencia: ${result.id}`, "success");
      } catch (error) {
        setUploadStatus(error.message || "No se pudo subir el archivo de forma segura.", "error");
      } finally {
        uploadButton.disabled = false;
      }
    });
  });

  document.querySelectorAll(".idp-newsletter-form").forEach((form) => {
    const tagsInput = form.querySelector("[data-idp-newsletter-tags]");

    const syncNewsletterTags = () => {
      if (!tagsInput) return;
      tagsInput.value = [
        "newsletter",
        "IDP Ibérica",
        "Envio semanal",
        "Consentimiento newsletter"
      ].join(", ");
    };

    syncNewsletterTags();

    form.addEventListener("submit", (event) => {
      if (!validateSpamProtectedForm(form)) {
        event.preventDefault();
      }
    });
  });

  document.querySelectorAll("[data-idp-colorizer]").forEach((colorizer) => {
    const preview = colorizer.querySelector("[data-idp-colorizer-preview]");
    const drawing = colorizer.querySelector("[data-idp-court-drawing]");
    const sportButtons = Array.from(colorizer.querySelectorAll("[data-idp-colorizer-sport]"));
    const viewButtons = Array.from(colorizer.querySelectorAll("[data-idp-colorizer-view]"));
    const zoneButtons = Array.from(colorizer.querySelectorAll("[data-idp-colorizer-zone]"));
    const colorButtons = Array.from(colorizer.querySelectorAll("[data-idp-colorizer-color]"));
    const resetButton = colorizer.querySelector("[data-idp-colorizer-reset]");
    const recommendationTitle = colorizer.querySelector("[data-idp-colorizer-recommendation-title]");
    const recommendationText = colorizer.querySelector("[data-idp-colorizer-recommendation-text]");
    const specTitle = colorizer.querySelector("[data-idp-colorizer-spec-title]");
    const specText = colorizer.querySelector("[data-idp-colorizer-spec-text]");

    const courts = {
      tennis: {
        label: "Tenis",
        length: 23.77,
        width: 10.97,
        title: "IDP Sport System · Tenis",
        text: "Sistema continuo para pista de tenis con acabado resistente, color estable y textura controlada.",
        specTitle: "Tenis · pista de dobles",
        specText: "Rectángulo de 23,77 x 10,97 m. Líneas de individuales a 8,23 m, pasillos de dobles, red central y cuadros de saque a 6,40 m de la red.",
        draw: "tennis"
      },
      futsal: {
        label: "Fútbol sala",
        length: 40,
        width: 20,
        title: "IDP Sport System · Fútbol sala",
        text: "Pavimento deportivo para pista polivalente con alta resistencia, buena lectura de líneas y mantenimiento sencillo.",
        specTitle: "Fútbol sala · pista 40 x 20 m",
        specText: "Campo rectangular de 40 x 20 m como referencia. Línea media, círculo central de 3 m, áreas de penalti a 6 m, punto de penalti a 6 m y segundo punto a 10 m.",
        draw: "futsal"
      },
      baloncesto: {
        label: "Baloncesto",
        length: 28,
        width: 15,
        title: "IDP Sport System · Baloncesto",
        text: "Sistema continuo para cancha de baloncesto con señalización de zonas, tiros libres y perímetro de triple.",
        specTitle: "Baloncesto · pista 28 x 15 m",
        specText: "Pista de 28 x 15 m. Línea central, círculo central, zonas restringidas, línea de tiro libre a 5,80 m de fondo y arco de triple a 6,75 m desde el aro.",
        draw: "basketball"
      },
      voleibol: {
        label: "Voleibol",
        length: 18,
        width: 9,
        title: "IDP Sport System · Voleibol",
        text: "Acabado deportivo para pista de voleibol con contraste entre campo, zonas de ataque y líneas.",
        specTitle: "Voleibol · campo 18 x 9 m",
        specText: "Campo de 18 x 9 m dividido por la red central. Línea de ataque a 3 m de la línea central en cada campo.",
        draw: "volleyball"
      },
      padel: {
        label: "Pádel",
        length: 20,
        width: 10,
        title: "IDP Sport System · Pádel",
        text: "Sistema coloreado para pista de pádel con acabado uniforme, agarre controlado y buena resistencia en uso intensivo.",
        specTitle: "Pádel · pista 20 x 10 m",
        specText: "Rectángulo de 20 x 10 m con cerramiento perimetral. Red central, líneas de servicio a 6,95 m de la red y línea central de saque.",
        draw: "padel"
      },
      basket3x3: {
        label: "Basket 3x3",
        length: 15,
        width: 11,
        title: "IDP Sport System · Basket 3x3",
        text: "Revestimiento para media pista 3x3 con marcaje urbano, alto contraste y presencia de marca perimetral.",
        specTitle: "Basket 3x3 · media pista 15 x 11 m",
        specText: "Media pista de 15 x 11 m con una canasta. Incluye zona restringida, tiro libre y arco de dos puntos a 6,75 m.",
        draw: "basket3x3"
      },
      badminton: {
        label: "Bádminton",
        length: 13.4,
        width: 6.1,
        title: "IDP Sport System · Bádminton",
        text: "Acabado para bádminton con líneas finas, contraste y lectura precisa de zonas de servicio.",
        specTitle: "Bádminton · pista de dobles 13,40 x 6,10 m",
        specText: "Pista de dobles de 13,40 x 6,10 m. Anchura de individuales 5,18 m, líneas de servicio corto a 1,98 m de la red y líneas de servicio largo.",
        draw: "badminton"
      },
      pickleball: {
        label: "Pickleball",
        length: 13.41,
        width: 6.1,
        title: "IDP Sport System · Pickleball",
        text: "Sistema para pickleball con cuadros de saque y zona de no volea claramente diferenciados.",
        specTitle: "Pickleball · pista 13,41 x 6,10 m",
        specText: "Pista de 44 x 20 pies, aproximadamente 13,41 x 6,10 m. Red central, zona de no volea de 7 pies por lado y cuadros de servicio.",
        draw: "pickleball"
      }
    };

    const defaultColors = {
      outer: "#0f5f2c",
      inner: "#16833a",
      lines: "#ffffff"
    };

    let activeZone = "outer";
    let activeSport = "tennis";

    const svg = (tag, attributes = {}) => {
      const element = document.createElementNS("http://www.w3.org/2000/svg", tag);
      Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, String(value)));
      return element;
    };

    const setColor = (zone, color) => {
      const property = {
        outer: "--idp-court-outer",
        inner: "--idp-court-inner",
        lines: "--idp-court-lines"
      }[zone];
      if (property) colorizer.style.setProperty(property, color);
    };

    const drawCourt = (sportKey = activeSport) => {
      if (!drawing) return;
      const court = courts[sportKey] || courts.tennis;
      const stage = { x: 54, y: 40, width: 812, height: 460 };
      const standSize = 44;
      const scale = Math.min(
        (stage.width - standSize * 2) / court.length,
        (stage.height - standSize * 2) / court.width
      );
      const length = court.length * scale;
      const width = court.width * scale;
      const x = stage.x + (stage.width - length) / 2;
      const y = stage.y + (stage.height - width) / 2;
      const mx = (meters) => x + meters * scale;
      const my = (meters) => y + meters * scale;
      const lineWidth = Math.max(2.3, Math.min(5, scale * 0.055));

      drawing.replaceChildren();
      drawing.appendChild(svg("rect", { class: "idp-colorizer__surface--outer", x: stage.x, y: stage.y, width: stage.width, height: stage.height, rx: 26 }));
      [
        [stage.x + 30, stage.y + 12, stage.width - 60, 30],
        [stage.x + 30, stage.y + stage.height - 42, stage.width - 60, 30],
        [stage.x + 12, stage.y + 56, 30, stage.height - 112],
        [stage.x + stage.width - 42, stage.y + 56, 30, stage.height - 112]
      ].forEach(([sx, sy, sw, sh]) => drawing.appendChild(svg("rect", { class: "idp-colorizer__stand", x: sx, y: sy, width: sw, height: sh, rx: 12 })));
      drawing.appendChild(svg("rect", { class: "idp-colorizer__surface--inner", x, y, width: length, height: width, rx: 5 }));

      const line = (x1, y1, x2, y2, extra = "") => drawing.appendChild(svg("line", { class: `idp-colorizer__line ${extra}`.trim(), x1, y1, x2, y2, "stroke-width": lineWidth }));
      const rect = (rx, ry, rw, rh) => drawing.appendChild(svg("rect", { class: "idp-colorizer__line", x: rx, y: ry, width: rw, height: rh, "stroke-width": lineWidth }));
      const circle = (cx, cy, r) => drawing.appendChild(svg("circle", { class: "idp-colorizer__line", cx, cy, r, "stroke-width": lineWidth }));
      const path = (d) => drawing.appendChild(svg("path", { class: "idp-colorizer__line", d, "stroke-width": lineWidth }));
      const text = (value, tx, ty, cls = "idp-colorizer__label") => {
        const item = svg("text", { class: cls, x: tx, y: ty, "text-anchor": "middle" });
        item.textContent = value;
        drawing.appendChild(item);
      };

      rect(x, y, length, width);

      if (court.draw === "tennis") {
        const inset = (10.97 - 8.23) / 2;
        line(mx(11.885), y, mx(11.885), y + width);
        line(x, my(inset), x + length, my(inset));
        line(x, my(10.97 - inset), x + length, my(10.97 - inset));
        line(mx(5.485), my(inset), mx(5.485), my(10.97 - inset));
        line(mx(18.285), my(inset), mx(18.285), my(10.97 - inset));
        line(mx(5.485), my(5.485), mx(18.285), my(5.485));
      } else if (court.draw === "futsal") {
        line(mx(20), y, mx(20), y + width);
        circle(mx(20), my(10), 3 * scale);
        path(`M ${mx(0)} ${my(2.5)} A ${6 * scale} ${6 * scale} 0 0 1 ${mx(6)} ${my(8.5)} L ${mx(6)} ${my(11.5)} A ${6 * scale} ${6 * scale} 0 0 1 ${mx(0)} ${my(17.5)}`);
        path(`M ${mx(40)} ${my(2.5)} A ${6 * scale} ${6 * scale} 0 0 0 ${mx(34)} ${my(8.5)} L ${mx(34)} ${my(11.5)} A ${6 * scale} ${6 * scale} 0 0 0 ${mx(40)} ${my(17.5)}`);
        circle(mx(6), my(10), 1.5);
        circle(mx(10), my(10), 1.5);
        circle(mx(34), my(10), 1.5);
        circle(mx(30), my(10), 1.5);
      } else if (court.draw === "basketball") {
        const hoopLeft = 1.575;
        const hoopRight = 26.425;
        const threePointRadius = 6.75;
        const sideOffset = 0.9;
        const threePointStart = Math.sqrt((threePointRadius ** 2) - ((7.5 - sideOffset) ** 2));
        const threeLeftX = hoopLeft + threePointStart;
        const threeRightX = hoopRight - threePointStart;
        line(mx(14), y, mx(14), y + width);
        circle(mx(14), my(7.5), 1.8 * scale);
        rect(mx(0), my(4.9), 5.8 * scale, 5.2 * scale);
        rect(mx(22.2), my(4.9), 5.8 * scale, 5.2 * scale);
        circle(mx(5.8), my(7.5), 1.8 * scale);
        circle(mx(22.2), my(7.5), 1.8 * scale);
        line(mx(0), my(sideOffset), mx(threeLeftX), my(sideOffset));
        line(mx(0), my(15 - sideOffset), mx(threeLeftX), my(15 - sideOffset));
        path(`M ${mx(threeLeftX)} ${my(sideOffset)} A ${threePointRadius * scale} ${threePointRadius * scale} 0 0 1 ${mx(threeLeftX)} ${my(15 - sideOffset)}`);
        line(mx(28), my(sideOffset), mx(threeRightX), my(sideOffset));
        line(mx(28), my(15 - sideOffset), mx(threeRightX), my(15 - sideOffset));
        path(`M ${mx(threeRightX)} ${my(sideOffset)} A ${threePointRadius * scale} ${threePointRadius * scale} 0 0 0 ${mx(threeRightX)} ${my(15 - sideOffset)}`);
      } else if (court.draw === "volleyball") {
        line(mx(9), y, mx(9), y + width);
        line(mx(6), y, mx(6), y + width);
        line(mx(12), y, mx(12), y + width);
      } else if (court.draw === "padel") {
        line(mx(10), y, mx(10), y + width);
        line(mx(3.05), y, mx(3.05), y + width);
        line(mx(16.95), y, mx(16.95), y + width);
        line(mx(2.85), my(5), mx(10), my(5));
        line(mx(10), my(5), mx(17.15), my(5));
      } else if (court.draw === "basket3x3") {
        const hoop = 1.575;
        const twoPointRadius = 6.75;
        const sideOffset = 0.9;
        const arcStart = hoop + Math.sqrt((twoPointRadius ** 2) - ((5.5 - sideOffset) ** 2));
        rect(mx(0), my(2.9), 5.8 * scale, 5.2 * scale);
        circle(mx(5.8), my(5.5), 1.8 * scale);
        line(mx(0), my(sideOffset), mx(arcStart), my(sideOffset));
        line(mx(0), my(11 - sideOffset), mx(arcStart), my(11 - sideOffset));
        path(`M ${mx(arcStart)} ${my(sideOffset)} A ${twoPointRadius * scale} ${twoPointRadius * scale} 0 0 1 ${mx(arcStart)} ${my(11 - sideOffset)}`);
        text("1 CANASTA", mx(1.15), my(5.5), "idp-colorizer__label idp-colorizer__label--small");
      } else if (court.draw === "badminton") {
        const inset = (6.1 - 5.18) / 2;
        line(mx(6.7), y, mx(6.7), y + width);
        line(x, my(inset), x + length, my(inset));
        line(x, my(6.1 - inset), x + length, my(6.1 - inset));
        line(mx(4.72), y, mx(4.72), y + width);
        line(mx(8.68), y, mx(8.68), y + width);
        line(x, my(3.05), mx(4.72), my(3.05));
        line(mx(8.68), my(3.05), x + length, my(3.05));
        line(mx(0.76), y, mx(0.76), y + width);
        line(mx(12.64), y, mx(12.64), y + width);
      } else if (court.draw === "pickleball") {
        line(mx(6.705), y, mx(6.705), y + width);
        line(mx(4.575), y, mx(4.575), y + width);
        line(mx(8.835), y, mx(8.835), y + width);
        line(x, my(3.05), mx(4.575), my(3.05));
        line(mx(8.835), my(3.05), x + length, my(3.05));
      }

      [
        [stage.x + 105, stage.y + 33],
        [stage.x + 255, stage.y + 33],
        [stage.x + 405, stage.y + 33],
        [stage.x + 555, stage.y + 33],
        [stage.x + 705, stage.y + 33],
        [stage.x + 105, stage.y + stage.height - 17],
        [stage.x + 255, stage.y + stage.height - 17],
        [stage.x + 405, stage.y + stage.height - 17],
        [stage.x + 555, stage.y + stage.height - 17],
        [stage.x + 705, stage.y + stage.height - 17],
        [stage.x + 27, stage.y + 135],
        [stage.x + 27, stage.y + 245],
        [stage.x + 27, stage.y + 355],
        [stage.x + stage.width - 27, stage.y + 135],
        [stage.x + stage.width - 27, stage.y + 245],
        [stage.x + stage.width - 27, stage.y + 355]
      ].forEach(([tx, ty], index) => {
        const value = ["IDP", "IDP SPORT", "IDP IBÉRICA", "IDP"][index % 4];
        text(value, tx, ty, `idp-colorizer__brand idp-colorizer__brand--${index % 3}`);
      });
      text(court.label.toUpperCase(), stage.x + stage.width / 2, stage.y + stage.height + 24, "idp-colorizer__sport-name");
      drawing.appendChild(svg("rect", { class: "idp-colorizer__shine", x: stage.x, y: stage.y, width: stage.width, height: stage.height, rx: 26 }));
    };

    const syncActiveColor = () => {
      const computedColor = getComputedStyle(colorizer)
        .getPropertyValue({
          outer: "--idp-court-outer",
          inner: "--idp-court-inner",
          lines: "--idp-court-lines"
        }[activeZone])
        .trim()
        .toLowerCase();

      colorButtons.forEach((button) => {
        button.classList.toggle(
          "is-active",
          button.dataset.idpColorizerColor.toLowerCase() === computedColor
        );
      });
    };

    sportButtons.forEach((button) => {
      button.addEventListener("click", () => {
        activeSport = button.dataset.idpColorizerSport;
        const court = courts[activeSport] || courts.tennis;
        if (preview) preview.dataset.sport = activeSport;
        sportButtons.forEach((item) => item.classList.toggle("is-active", item === button));
        if (recommendationTitle) recommendationTitle.textContent = court.title;
        if (recommendationText) recommendationText.textContent = court.text;
        if (specTitle) specTitle.textContent = court.specTitle;
        if (specText) specText.textContent = court.specText;
        drawCourt(activeSport);
      });
    });

    viewButtons.forEach((button) => {
      button.addEventListener("click", () => {
        if (preview) preview.dataset.view = button.dataset.idpColorizerView;
        viewButtons.forEach((item) => item.classList.toggle("is-active", item === button));
      });
    });

    zoneButtons.forEach((button) => {
      button.addEventListener("click", () => {
        activeZone = button.dataset.idpColorizerZone;
        zoneButtons.forEach((item) => item.classList.toggle("is-active", item === button));
        syncActiveColor();
      });
    });

    colorButtons.forEach((button) => {
      button.addEventListener("click", () => {
        setColor(activeZone, button.dataset.idpColorizerColor);
        syncActiveColor();
      });
    });

    resetButton?.addEventListener("click", () => {
      Object.entries(defaultColors).forEach(([zone, color]) => setColor(zone, color));
      activeZone = "outer";
      zoneButtons.forEach((button) => {
        button.classList.toggle("is-active", button.dataset.idpColorizerZone === activeZone);
      });
      drawCourt(activeSport);
      syncActiveColor();
    });

    Object.entries(defaultColors).forEach(([zone, color]) => setColor(zone, color));
    drawCourt(activeSport);
    syncActiveColor();
  });

  document.querySelectorAll("[data-idp-industrial-colors]").forEach((industrial) => {
    const industrialLogoDetailSrc = industrial.querySelector(".idp-industrial-colors__scene-base")?.src
      ?.replace(/idp-industrial-hall-realistic-base\.png.*/, "idp-logo-white-detail.png") || "";
    const ralClassic = [
      {code:"1000",hex:"#CDBA88",name:"Green beige"},{code:"1001",hex:"#D0B084",name:"Beige"},{code:"1002",hex:"#D2AA6D",name:"Sand yellow"},{code:"1003",hex:"#F9A900",name:"Signal yellow"},{code:"1004",hex:"#E49E00",name:"Golden yellow"},{code:"1005",hex:"#CB8F00",name:"Honey yellow"},{code:"1006",hex:"#E19000",name:"Maize yellow"},{code:"1007",hex:"#E88C00",name:"Daffodil yellow"},{code:"1011",hex:"#AF8050",name:"Brown beige"},{code:"1012",hex:"#DDAF28",name:"Lemon yellow"},{code:"1013",hex:"#E3D9C7",name:"Oyster white"},{code:"1014",hex:"#DDC49B",name:"Ivory"},{code:"1015",hex:"#E6D2B5",name:"Light ivory"},{code:"1016",hex:"#F1DD39",name:"Sulfur yellow"},{code:"1017",hex:"#F6A951",name:"Saffron yellow"},{code:"1018",hex:"#FACA31",name:"Zinc yellow"},{code:"1019",hex:"#A48F7A",name:"Grey beige"},{code:"1020",hex:"#A08F65",name:"Olive yellow"},{code:"1021",hex:"#F6B600",name:"Colza yellow"},{code:"1023",hex:"#F7B500",name:"Traffic yellow"},{code:"1024",hex:"#BA8F4C",name:"Ochre yellow"},{code:"1026",hex:"#FFFF00",name:"Luminous yellow"},{code:"1027",hex:"#A77F0F",name:"Curry"},{code:"1028",hex:"#FF9C00",name:"Melon yellow"},{code:"1032",hex:"#E2A300",name:"Broom yellow"},{code:"1033",hex:"#F99A1D",name:"Dahlia yellow"},{code:"1034",hex:"#EB9C52",name:"Pastel yellow"},{code:"1035",hex:"#8F8370",name:"Pearl beige"},{code:"1036",hex:"#806440",name:"Pearl gold"},{code:"1037",hex:"#F09200",name:"Sun yellow"},{code:"2000",hex:"#DA6E00",name:"Yellow orange"},{code:"2001",hex:"#BA481C",name:"Red orange"},{code:"2002",hex:"#BF3922",name:"Vermilion"},{code:"2003",hex:"#F67829",name:"Pastel orange"},{code:"2004",hex:"#E25304",name:"Pure orange"},{code:"2005",hex:"#FF4D08",name:"Luminous orange"},{code:"2007",hex:"#FFB200",name:"Luminous bright orange"},{code:"2008",hex:"#EC6B22",name:"Bright red orange"},{code:"2009",hex:"#DE5308",name:"Traffic orange"},{code:"2010",hex:"#D05D29",name:"Signal orange"},{code:"2011",hex:"#E26E0F",name:"Deep orange"},{code:"2012",hex:"#D5654E",name:"Salmon orange"},{code:"2013",hex:"#923E25",name:"Pearl orange"},{code:"2017",hex:"#FC5500",name:"RAL orange"},{code:"3000",hex:"#A72920",name:"Flame red"},{code:"3001",hex:"#9B2423",name:"Signal red"},{code:"3002",hex:"#9B2321",name:"Carmine red"},{code:"3003",hex:"#861A22",name:"Ruby red"},{code:"3004",hex:"#6B1C23",name:"Purple red"},{code:"3005",hex:"#59191F",name:"Wine red"},{code:"3007",hex:"#3E2022",name:"Black red"},{code:"3009",hex:"#6D342D",name:"Oxide red"},{code:"3011",hex:"#782423",name:"Brown red"},{code:"3012",hex:"#C5856D",name:"Beige red"},{code:"3013",hex:"#972E25",name:"Tomato red"},{code:"3014",hex:"#CB7375",name:"Antique pink"},{code:"3015",hex:"#D8A0A6",name:"Light pink"},{code:"3016",hex:"#A63D30",name:"Coral red"},{code:"3017",hex:"#CA555D",name:"Rose"},{code:"3018",hex:"#C63F4A",name:"Strawberry red"},{code:"3020",hex:"#BB1F11",name:"Traffic red"},{code:"3022",hex:"#CF6955",name:"Salmon pink"},{code:"3024",hex:"#FF2D21",name:"Luminous red"},{code:"3026",hex:"#FF2A1C",name:"Luminous bright red"},{code:"3027",hex:"#AB273C",name:"Raspberry red"},{code:"3028",hex:"#CC2C24",name:"Pure red"},{code:"3031",hex:"#A63437",name:"Orient red"},{code:"3032",hex:"#701D24",name:"Pearl ruby red"},{code:"3033",hex:"#A53A2E",name:"Pearl pink"},{code:"4001",hex:"#816183",name:"Red lilac"},{code:"4002",hex:"#8D3C4B",name:"Red violet"},{code:"4003",hex:"#C4618C",name:"Heather violet"},{code:"4004",hex:"#651E38",name:"Claret violet"},{code:"4005",hex:"#76689A",name:"Blue lilac"},{code:"4006",hex:"#903373",name:"Traffic purple"},{code:"4007",hex:"#47243C",name:"Purple violet"},{code:"4008",hex:"#844C82",name:"Signal violet"},{code:"4009",hex:"#9D8692",name:"Pastel violet"},{code:"4010",hex:"#BB4077",name:"Telemagenta"},{code:"4011",hex:"#6E6387",name:"Pearl violet"},{code:"4012",hex:"#6A6B7F",name:"Pearl blackberry"},{code:"5000",hex:"#304F6E",name:"Violet blue"},{code:"5001",hex:"#0E4C64",name:"Green blue"},{code:"5002",hex:"#00387A",name:"Ultramarine blue"},{code:"5003",hex:"#1F3855",name:"Sapphire blue"},{code:"5004",hex:"#191E28",name:"Black blue"},{code:"5005",hex:"#005387",name:"Signal blue"},{code:"5007",hex:"#376B8C",name:"Brillant blue"},{code:"5008",hex:"#2B3A44",name:"Grey blue"},{code:"5009",hex:"#215F78",name:"Azure blue"},{code:"5010",hex:"#004F7C",name:"Gentian blue"},{code:"5011",hex:"#1A2B3C",name:"Steel blue"},{code:"5012",hex:"#0089B6",name:"Light blue"},{code:"5013",hex:"#193153",name:"Cobalt blue"},{code:"5014",hex:"#637D96",name:"Pigeon blue"},{code:"5015",hex:"#007CAF",name:"Sky blue"},{code:"5017",hex:"#005B8C",name:"Traffic blue"},{code:"5018",hex:"#048B8C",name:"Turquoise blue"},{code:"5019",hex:"#005E83",name:"Capri blue"},{code:"5020",hex:"#00414B",name:"Ocean blue"},{code:"5021",hex:"#007577",name:"Water blue"},{code:"5022",hex:"#222D5A",name:"Night blue"},{code:"5023",hex:"#41698C",name:"Distant blue"},{code:"5024",hex:"#6093AC",name:"Pastel blue"},{code:"5025",hex:"#20697C",name:"Pearl gentian blue"},{code:"5026",hex:"#0F3052",name:"Pearl night blue"},{code:"6000",hex:"#3C7460",name:"Patina green"},{code:"6001",hex:"#366735",name:"Emerald green"},{code:"6002",hex:"#325928",name:"Leaf green"},{code:"6003",hex:"#50533C",name:"Olive green"},{code:"6004",hex:"#024442",name:"Blue green"},{code:"6005",hex:"#114232",name:"Moss green"},{code:"6006",hex:"#3C392E",name:"Grey olive"},{code:"6007",hex:"#2C3222",name:"Bottle green"},{code:"6008",hex:"#36342A",name:"Brown green"},{code:"6009",hex:"#27352A",name:"Fir green"},{code:"6010",hex:"#4D6F39",name:"Grass green"},{code:"6011",hex:"#6B7C59",name:"Reseda green"},{code:"6012",hex:"#2F3D3A",name:"Black green"},{code:"6013",hex:"#7C765A",name:"Reed green"},{code:"6014",hex:"#474135",name:"Yellow olive"},{code:"6015",hex:"#3D3D36",name:"Black olive"},{code:"6016",hex:"#00694C",name:"Turquoise green"},{code:"6017",hex:"#587F40",name:"May green"},{code:"6018",hex:"#60993B",name:"Yellow green"},{code:"6019",hex:"#B9CEAC",name:"Pastel green"},{code:"6020",hex:"#37422F",name:"Chrome green"},{code:"6021",hex:"#8A9977",name:"Pale green"},{code:"6022",hex:"#3A3327",name:"Olive drab"},{code:"6024",hex:"#008351",name:"Traffic green"},{code:"6025",hex:"#5E6E3B",name:"Fern green"},{code:"6026",hex:"#005F4E",name:"Opal green"},{code:"6027",hex:"#7EBAB5",name:"Light green"},{code:"6028",hex:"#315442",name:"Pine green"},{code:"6029",hex:"#006F3D",name:"Mint green"},{code:"6032",hex:"#237F52",name:"Signal green"},{code:"6033",hex:"#45877F",name:"Mint turquoise"},{code:"6034",hex:"#7AADAC",name:"Pastel turquoise"},{code:"6035",hex:"#194D25",name:"Pearl green"},{code:"6036",hex:"#04574B",name:"Pearl opal green"},{code:"6037",hex:"#008B29",name:"Pure green"},{code:"6038",hex:"#00B51B",name:"Luminous green"},{code:"6039",hex:"#B3C43E",name:"Fibrous green"},{code:"7000",hex:"#7A888E",name:"Squirrel grey"},{code:"7001",hex:"#8C979C",name:"Silver grey"},{code:"7002",hex:"#817863",name:"Olive grey"},{code:"7003",hex:"#797669",name:"Moss grey"},{code:"7004",hex:"#9A9B9B",name:"Signal grey"},{code:"7005",hex:"#6B6E6B",name:"Mouse grey"},{code:"7006",hex:"#766A5E",name:"Beige grey"},{code:"7008",hex:"#745F3D",name:"Khaki grey"},{code:"7009",hex:"#5D6058",name:"Green grey"},{code:"7010",hex:"#585C56",name:"Tarpaulin grey"},{code:"7011",hex:"#52595D",name:"Iron grey"},{code:"7012",hex:"#575D5E",name:"Basalt grey"},{code:"7013",hex:"#575044",name:"Brown grey"},{code:"7015",hex:"#4F5358",name:"Slate grey"},{code:"7016",hex:"#383E42",name:"Anthracite grey"},{code:"7021",hex:"#2F3234",name:"Black grey"},{code:"7022",hex:"#4C4A44",name:"Umbra grey"},{code:"7023",hex:"#808076",name:"Concrete grey"},{code:"7024",hex:"#45494E",name:"Graphite grey"},{code:"7026",hex:"#374345",name:"Granite grey"},{code:"7030",hex:"#928E85",name:"Stone grey"},{code:"7031",hex:"#5B686D",name:"Blue grey"},{code:"7032",hex:"#B5B0A1",name:"Pebble grey"},{code:"7033",hex:"#7F8274",name:"Cement grey"},{code:"7034",hex:"#92886F",name:"Yellow grey"},{code:"7035",hex:"#C5C7C4",name:"Light grey"},{code:"7036",hex:"#979392",name:"Platinum grey"},{code:"7037",hex:"#7A7B7A",name:"Dusty grey"},{code:"7038",hex:"#B0B0A9",name:"Agate grey"},{code:"7039",hex:"#6B665E",name:"Quartz grey"},{code:"7040",hex:"#989EA1",name:"Window grey"},{code:"7042",hex:"#8E9291",name:"Traffic grey A"},{code:"7043",hex:"#4F5250",name:"Traffic grey B"},{code:"7044",hex:"#B7B3A8",name:"Silk grey"},{code:"7045",hex:"#8D9295",name:"Telegrey 1"},{code:"7046",hex:"#7E868A",name:"Telegrey 2"},{code:"7047",hex:"#C8C8C7",name:"Telegrey 4"},{code:"7048",hex:"#817B73",name:"Pearl mouse grey"},{code:"8000",hex:"#89693F",name:"Green brown"},{code:"8001",hex:"#9D622B",name:"Ochre brown"},{code:"8002",hex:"#794D3E",name:"Signal brown"},{code:"8003",hex:"#7E4B27",name:"Clay brown"},{code:"8004",hex:"#8D4931",name:"Copper brown"},{code:"8007",hex:"#70462B",name:"Fawn brown"},{code:"8008",hex:"#724A25",name:"Olive brown"},{code:"8011",hex:"#5A3827",name:"Nut brown"},{code:"8012",hex:"#66332B",name:"Red brown"},{code:"8014",hex:"#4A3526",name:"Sepia brown"},{code:"8015",hex:"#5E2F26",name:"Chestnut brown"},{code:"8016",hex:"#4C2B20",name:"Mahogany brown"},{code:"8017",hex:"#442F29",name:"Chocolate brown"},{code:"8019",hex:"#3D3635",name:"Grey brown"},{code:"8022",hex:"#1A1719",name:"Black brown"},{code:"8023",hex:"#A45729",name:"Orange brown"},{code:"8024",hex:"#795038",name:"Beige brown"},{code:"8025",hex:"#755847",name:"Pale brown"},{code:"8028",hex:"#513A2A",name:"Terra brown"},{code:"8029",hex:"#7F4031",name:"Pearl copper"},{code:"9001",hex:"#E9E0D2",name:"Cream"},{code:"9002",hex:"#D6D5CB",name:"Grey white"},{code:"9003",hex:"#ECECE7",name:"Signal white"},{code:"9004",hex:"#2B2B2C",name:"Signal black"},{code:"9005",hex:"#0E0E10",name:"Jet black"},{code:"9006",hex:"#A1A1A0",name:"White aluminium"},{code:"9007",hex:"#868581",name:"Grey aluminium"},{code:"9010",hex:"#F1EDE1",name:"Pure white"},{code:"9011",hex:"#27292B",name:"Graphite black"},{code:"9012",hex:"#F8F2E1",name:"Cleanroom white"},{code:"9016",hex:"#F1F1EA",name:"Traffic white"},{code:"9017",hex:"#29292A",name:"Traffic black"},{code:"9018",hex:"#C8CBC4",name:"Papyrus white"},{code:"9022",hex:"#858583",name:"Pearl light grey"},{code:"9023",hex:"#787B7A",name:"Pearl dark grey"}
    ];

    const palette = industrial.querySelector("[data-idp-industrial-palette]");
    const search = industrial.querySelector("[data-idp-industrial-search]");
    const summary = industrial.querySelector("[data-idp-industrial-summary]");
    const hexValue = industrial.querySelector("[data-idp-industrial-hex]");
    const finishInfo = industrial.querySelector("[data-idp-industrial-finish-info]");
    const request = industrial.querySelector("[data-idp-industrial-request]");
    const reset = industrial.querySelector("[data-idp-industrial-reset]");
    const finishButtons = Array.from(industrial.querySelectorAll("[data-idp-industrial-finish]"));
    const state = {
      floor: ralClassic.find((item) => item.code === "7035"),
      finish: "gloss"
    };

    const finishLabels = {
      gloss: "Brillante",
      satin: "Satinado",
      matte: "Mate"
    };
    const finishDetails = {
      gloss: {
        title: "Brillo · más de 60 gloss",
        text: "Reflexión directa y alta. Aspecto luminoso, efecto espejo y llamativo. Facilita mucho la limpieza, aunque hace más visibles los defectos del soporte."
      },
      satin: {
        title: "Satinado · entre 10 y 60 gloss",
        text: "Reflexión intermedia. Aspecto suave, sedoso y equilibrado. Combina elegancia, resistencia y facilidad de lavado."
      },
      matte: {
        title: "Mate · menos de 10 gloss",
        text: "Reflexión mínima y aspecto opaco, plano y suave. Oculta muy bien los defectos, aunque exige más atención durante la limpieza."
      }
    };
    const applyState = () => {
      industrial.style.setProperty("--idp-industrial-floor", state.floor.hex);
      industrial.dataset.finish = state.finish;
      industrial.style.setProperty("--idp-industrial-active", state.floor.hex);
      if (summary) {
        summary.textContent = `Suelo RAL ${state.floor.code} · ${state.floor.name} | Acabado ${finishLabels[state.finish]}`;
      }
      if (hexValue) hexValue.textContent = state.floor.hex.toUpperCase();
      if (finishInfo) {
        const detail = finishDetails[state.finish];
        finishInfo.innerHTML = `<strong>${detail.title}</strong><p>${detail.text}</p>`;
      }
      palette?.querySelectorAll("[data-ral]").forEach((button) => {
        button.classList.toggle("is-active", button.dataset.ral === state.floor.code);
        button.setAttribute("aria-pressed", button.dataset.ral === state.floor.code ? "true" : "false");
      });
      finishButtons.forEach((button) => {
        button.classList.toggle("is-active", button.dataset.idpIndustrialFinish === state.finish);
        button.setAttribute("aria-pressed", button.dataset.idpIndustrialFinish === state.finish ? "true" : "false");
      });
    };

    const renderPalette = () => {
      if (!palette) return;
      const term = (search?.value || "").trim().toLowerCase();
      const fragment = document.createDocumentFragment();
      ralClassic
        .filter((item) => !term || item.code.includes(term) || item.name.toLowerCase().includes(term))
        .forEach((item) => {
          const button = document.createElement("button");
          button.type = "button";
          button.dataset.ral = item.code;
          button.style.setProperty("--swatch", item.hex);
          button.setAttribute("aria-label", `Aplicar RAL ${item.code} ${item.name}`);
          button.innerHTML = `<span class="idp-industrial-colors__ral-logo" aria-hidden="true"><img src="${industrialLogoDetailSrc}" alt="" loading="lazy"></span><strong>RAL ${item.code}</strong><small>${item.name}<code>${item.hex}</code></small>`;
          button.addEventListener("click", () => {
            state.floor = item;
            applyState();
          });
          fragment.appendChild(button);
        });
      palette.replaceChildren(fragment);
      applyState();
    };

    finishButtons.forEach((button) => {
      button.addEventListener("click", () => {
        state.finish = button.dataset.idpIndustrialFinish;
        applyState();
      });
    });

    search?.addEventListener("input", renderPalette);
    reset?.addEventListener("click", () => {
      state.floor = ralClassic.find((item) => item.code === "7035");
      state.finish = "gloss";
      applyState();
    });
    request?.addEventListener("click", () => {
      const body = [
        "Solicitud de combinación de colores industriales IDP.",
        "",
        `Suelo: RAL ${state.floor.code} · ${state.floor.name}`,
        `Acabado: ${finishLabels[state.finish]}`,
        "",
        "Me gustaría recibir asesoramiento y propuesta técnica para esta configuración."
      ].join("\n");
      window.localStorage.setItem(pendingContactKey, JSON.stringify({
        subject: "Consulta colores industriales IDP",
        body
      }));
    });

    renderPalette();
  });

  const themeAsset = document.querySelector('img[src*="/cdn/shop/t/"][src*="/assets/"]');
  const themeAssetSrc = themeAsset?.currentSrc || themeAsset?.src || "";
  const themeAssetBase = themeAssetSrc.includes("/assets/")
    ? themeAssetSrc.split("/assets/")[0]
    : "";

  if (themeAssetBase) {
    const mappedProductImages = [
      { pattern: /chips decorativos/i, file: "idp-chips-decorative-floor-hd.png" },
      { pattern: /flexifloor/i, file: "idp-flexifloor-industrial-floor-hd.png" },
      { pattern: /aliflex|aspatric|aspartic|monodur/i, file: "epoxy-products-branded.png" }
    ];
    const productMedia = document.querySelectorAll(
      ".idp-product-card__media > img, .idp-product__image-wrap > img, .idp-cart-item__media > img"
    );

    productMedia.forEach((image) => {
      const productContext = image.closest(
        ".idp-product-card, .idp-product__grid, .idp-cart-item"
      );
      const mapping = mappedProductImages.find(({ pattern }) =>
        pattern.test(productContext?.textContent || "")
      );
      if (!productContext || !mapping) return;

      image.src = `${themeAssetBase}/assets/${mapping.file}`;
      image.removeAttribute("srcset");
      image.removeAttribute("sizes");
      image.alt = `Imagen técnica de ${productContext.querySelector("h1, h2, h3")?.textContent.trim() || "producto técnico"}`;
      image.closest(".idp-product-card__media")?.classList.add("idp-product-card__media--mapped");
    });
  }

  if (header) {
    const syncHeader = () => {
      header.classList.toggle("is-scrolled", window.scrollY > 12);
    };

    syncHeader();
    window.addEventListener("scroll", syncHeader, { passive: true });
  }

  if (header && toggle) {
    const menuPanel = header.querySelector("#IdpMainMenu");

    const closeMenu = () => {
      header.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-label", "Abrir menú");
      menuPanel?.setAttribute("aria-hidden", "true");
    };

    closeMenu();

    toggle.addEventListener("click", () => {
      const isOpen = header.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", String(isOpen));
      toggle.setAttribute("aria-label", isOpen ? "Cerrar menú" : "Abrir menú");
      menuPanel?.setAttribute("aria-hidden", String(!isOpen));
    });

    header.querySelectorAll(".idp-nav a").forEach((link) => {
      link.addEventListener("click", closeMenu);
    });

    window.addEventListener("pageshow", closeMenu);
    window.addEventListener("resize", closeMenu, { passive: true });

    document.addEventListener("click", (event) => {
      if (header.classList.contains("is-open") && !header.contains(event.target)) closeMenu();
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closeMenu();
    });
  }

  document.querySelectorAll(
    ".idp-product a, .idp-product-card a, .idp-doc-card, .idp-doc-product-list__actions a"
  ).forEach((link) => {
    const technicalReference = `${link.textContent} ${link.getAttribute("href") || ""}`;
    if (!/ficha|pdf|#contacto/i.test(technicalReference)) return;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
  });

  const copyShareText = async (text) => {
    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(text);
        return;
      } catch (error) {
        // Continue with the compatible selection-based fallback.
      }
    }

    const field = document.createElement("textarea");
    field.value = text;
    field.setAttribute("readonly", "");
    field.style.position = "fixed";
    field.style.opacity = "0";
    document.body.appendChild(field);
    field.select();
    const copied = document.execCommand("copy");
    field.remove();
    if (!copied) throw new Error("Copy command unavailable");
  };

  const setShareStatus = (button, message) => {
    const status = button.closest("[data-idp-share]")?.querySelector(".idp-share__status");
    if (!status) return;
    status.textContent = message;
    window.setTimeout(() => {
      if (status.textContent === message) status.textContent = "";
    }, 3500);
  };

  document.addEventListener("click", async (event) => {
    const copyButton = event.target.closest("[data-idp-copy-share]");
    const nativeButton = event.target.closest("[data-idp-native-share]");
    const button = copyButton || nativeButton;
    if (!button) return;

    const title = button.dataset.shareTitle || document.title;
    const url = button.dataset.shareUrl || window.location.href;
    const text = `Mira este producto de IDP: ${title}`;

    if (nativeButton && navigator.share) {
      try {
        await navigator.share({ title, text, url });
        setShareStatus(button, "Contenido compartido.");
        return;
      } catch (error) {
        if (error?.name === "AbortError") return;
      }
    }

    try {
      await copyShareText(`${text} — ${url}`);
      setShareStatus(button, "Texto y enlace copiados. Ya puedes pegarlos en tu red social.");
    } catch (error) {
      setShareStatus(button, "No se pudo copiar. Mantén pulsado el enlace de la página para compartirlo.");
    }
  });

  if (slider) {
    const slides = Array.from(slider.querySelectorAll("[data-idp-slide]"));
    const dots = Array.from(slider.querySelectorAll("[data-idp-dot]"));
    const prev = slider.querySelector("[data-idp-prev]");
    const next = slider.querySelector("[data-idp-next]");
    let current = Math.max(0, slides.findIndex((slide) => slide.classList.contains("is-active")));
    let timer;

    const newsItems = [
      {
        title: "Impermeabilización continua para cubiertas técnicas",
        text: "Hoy destacamos membranas líquidas para terrazas, cubiertas y detalles difíciles: una solución limpia cuando se busca continuidad y buena adherencia."
      },
      {
        title: "Pavimentos epoxi para zonas de alto desgaste",
        text: "Los sistemas autonivelantes y multicapa ayudan a proteger superficies industriales, parkings y áreas comerciales con mantenimiento sencillo."
      },
      {
        title: "Acabados y selladores para prolongar la vida del sistema",
        text: "Un buen acabado mejora resistencia, limpieza y estética. Revisa top coats, selladores y chips decorativos según el uso final del pavimento."
      },
      {
        title: "Imprimaciones para preparar soportes exigentes",
        text: "La elección de imprimación condiciona adherencia y durabilidad. En soportes húmedos o porosos conviene revisar la ficha técnica antes de aplicar."
      }
    ];

    const dayIndex = Math.floor(Date.now() / 86400000) % newsItems.length;
    const news = newsItems[dayIndex];
    const newsTitle = slider.querySelector("[data-idp-news-title]");
    const newsText = slider.querySelector("[data-idp-news-text]");
    if (newsTitle && newsText) {
      newsTitle.textContent = news.title;
      newsText.textContent = news.text;
    }

    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => slide.classList.toggle("is-active", slideIndex === current));
      dots.forEach((dot, dotIndex) => dot.classList.toggle("is-active", dotIndex === current));
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
    };

    const start = () => {
      stop();
      timer = window.setInterval(() => show(current + 1), 6500);
    };

    prev?.addEventListener("click", () => {
      show(current - 1);
      start();
    });

    next?.addEventListener("click", () => {
      show(current + 1);
      start();
    });

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        show(index);
        start();
      });
    });

    slider.addEventListener("mouseenter", stop);
    slider.addEventListener("mouseleave", start);
    start();
  }

  const revealTargets = document.querySelectorAll(
    ".idp-quick-link, .idp-category-card, .idp-feature-card, .idp-product-card, .idp-image-frame, .idp-doc-card, .idp-cta__inner, .idp-colorizer__stage, .idp-colorizer__panel, .idp-industrial-colors__scene, .idp-industrial-colors__panel, .idp-newsletter__content, .idp-newsletter__panel"
  );

  revealTargets.forEach((element) => {
    element.setAttribute("data-idp-reveal", "");
  });

  if (!("IntersectionObserver" in window)) {
    revealTargets.forEach((element) => element.classList.add("is-visible"));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: "0px 0px -8% 0px", threshold: 0.14 }
  );

  revealTargets.forEach((element) => observer.observe(element));
});
